"use client";

import { useState } from "react";

export default function CalendarGrid() {
  const [month, setMonth] = useState(9);
  const [year, setYear] = useState(2026);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const daysInMonth = new Date(
    year,
    month + 1,
    0
  ).getDate();

  const firstDay = new Date(
    year,
    month,
    1
  ).getDay();

  const mondayOffset =
    firstDay === 0
      ? 6
      : firstDay - 1;

  const days = Array.from(
    { length: daysInMonth },
    (_, i) => i + 1
  );

  function previous() {
    if (month === 0) {
      setMonth(11);
      setYear(year - 1);
    } else {
      setMonth(month - 1);
    }
  }

  function next() {
    if (month === 11) {
      setMonth(0);
      setYear(year + 1);
    } else {
      setMonth(month + 1);
    }
  }

  return (
    <div>

      <div className="flex items-center justify-between gap-4">

        <div>

          <p className="text-xs sm:text-sm text-gray-500">
            CALENDAR
          </p>

          <h1 className="text-2xl sm:text-4xl font-semibold mt-1">
            {months[month]} {year}
          </h1>

        </div>

        <div className="flex gap-2 shrink-0">

          <button
            type="button"
            onClick={previous}
            aria-label="Previous month"
            className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-[#292e35] hover:bg-[#333941]"
          >
            ←
          </button>

          <button
            type="button"
            onClick={next}
            aria-label="Next month"
            className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-[#292e35] hover:bg-[#333941]"
          >
            →
          </button>

        </div>

      </div>

      <div className="mt-5 sm:mt-8 rounded-2xl bg-[#181b1f] border border-white/10 p-2 sm:p-6 overflow-x-auto">

        <div className="min-w-[600px]">

          <div className="grid grid-cols-7 text-center">

            {[
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday",
            ].map((day) => (

              <div
                key={day}
                className="text-xs text-gray-500 py-3"
              >

                <span className="hidden sm:inline">
                  {day}
                </span>

                <span className="sm:hidden">
                  {day.substring(0, 3)}
                </span>

              </div>

            ))}

            {Array.from({
              length: mondayOffset,
            }).map((_, index) => (
              <div key={`empty-${index}`} />
            ))}

            {days.map((day) => {

              const today =
                day === 5 &&
                month === 9 &&
                year === 2026;

              return (
                <div
                  key={day}
                  className={`min-h-20 sm:h-24 border border-white/5 p-2 sm:p-3 text-left ${
                    today
                      ? "bg-blue-600/20"
                      : "hover:bg-white/5"
                  }`}
                >

                  <span
                    className={`text-xs sm:text-sm ${
                      today
                        ? "bg-blue-600 rounded-full w-7 h-7 flex items-center justify-center"
                        : ""
                    }`}
                  >
                    {day}
                  </span>

                  {today && (
                    <p className="text-[10px] sm:text-xs text-blue-300 mt-2 sm:mt-3">
                      Server maintenance
                    </p>
                  )}

                </div>
              );
            })}

          </div>

        </div>

      </div>

    </div>
  );
}